module.exports = __webpack_public_path__ + "static/blog20-b13739e84eefe2612f8cb4818c55d8d2.png";